// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"904": "574583d985ba5225","955": "b78d6ade3bbcd461",}[chunkId] + ".css"
}